

// pages/Profile.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import UserAvatar from "../components/UserAvatar";
import { getServiceAvailablePlaces, hasUpcomingCreneau, isServicePast } from "../utils/serviceUtils";


const Profile = () => {
  const [user, setUser] = useState(null);
  const [services, setServices] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [reservationsRecues, setReservationsRecues] = useState([]);
  const [avis, setAvis] = useState([]);
  const [isPhotoUploading, setIsPhotoUploading] = useState(false);
  const [activeTab, setActiveTab] = useState("about");
  const [, setEditMode] = useState(false);
  const [cancelMessage, setCancelMessage] = useState("");
  const [serviceActionMessage, setServiceActionMessage] = useState("");
// Mode édition
 // const [form, setForm] = useState({});
  const navigate = useNavigate();
  const photoInputRef = useRef(null);




  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    if (!userData || !token) return navigate("/login");
const userId = (userData.id || userData._id || "").trim();

    // Charger le profil
   axios
  .get(`https://backend-qybe.onrender.com/api/users/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  .then((res) => {
    setUser(res.data);
  })
  .catch((err) => {
    console.error("Erreur de chargement utilisateur :", err);
  });


      // Charger les avis
      axios.get(`https://backend-qybe.onrender.com/api/avis/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((resAvis) => {
    const avis = resAvis.data;
    setAvis(avis);

    const avisAvecNote = avis.filter((a) => {
      const n = typeof a.note === "string" ? parseFloat(a.note) : a.note;
      return typeof n === "number" && !isNaN(n) && n >= 1 && n <= 5;
    });

    const noteMoyenne = avisAvecNote.length > 0
      ? (avisAvecNote.map(a => typeof a.note === "string" ? parseFloat(a.note) : a.note)
          .reduce((acc, n) => acc + n, 0) / avisAvecNote.length).toFixed(1)
      : null;

   setUser(prev => ({
  ...prev,
  note: noteMoyenne,
  nombreAvis: avis.length
}));
 // Initialiser le formulaire
  })
  .catch((err) => console.error("Erreur de chargement des avis :", err));


    if (userData.role === "createur") {
      axios.get(`https://backend-qybe.onrender.com/api/services/serv/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then(async (res) => {
        const rawServices = res.data;
        // Filtrer les services complets (mod #6)
        const servicesWithCount = await Promise.all(
          rawServices.map(async (s) => {
            try {
              const countRes = await axios.get(
                `https://backend-qybe.onrender.com/api/reservations/count/${s._id}`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              const backendRemaining = Number(s?.placesRestantes);
              const totalPlaces = Number.isFinite(backendRemaining) && backendRemaining >= 0
                ? backendRemaining
                : Number(getServiceAvailablePlaces(s) || 1);
              const placesRestantes = Number.isFinite(backendRemaining) && backendRemaining >= 0
                ? backendRemaining
                : Math.max(totalPlaces - (countRes.data.count || 0), 0);
              return { ...s, placesRestantes, reservationsCount: countRes.data.count || 0 };
            } catch {
              return { ...s, placesRestantes: 1, reservationsCount: 0 }; // par défaut visible
            }
          })
        );
        const isServiceActive = (s) =>
          s?.isActive !== false &&
          s?.active !== false &&
          s?.desactive !== true &&
          s?.status !== "inactive";

        setServices(
          servicesWithCount.filter(
            (s) => s.placesRestantes > 0 && isServiceActive(s) && hasUpcomingCreneau(s) && !isServicePast(s)
          )
        );
      });

      // Charger les réservations reçues sur mes services (mod #7)
      axios.get(`https://backend-qybe.onrender.com/api/reservations/creator/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((res) => setReservationsRecues(res.data || []))
        .catch(() => setReservationsRecues([]));
    }

    axios.get(`https://backend-qybe.onrender.com/api/reservations/user/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((res) => setReservations(res.data));
  }, [navigate]);

  if (!user) return <p className="text-center py-10">Chargement...</p>;
  console.log("LINKS:", user.siteWeb, user.instagram, user.linkedin);

  const creatorContactEmail = user?.emailDeContact || user?.mailDeContact || user?.contactEmail || null;

  const aboutTabLabel = user.role === "particulier" ? "Coordonnées" : "À propos de moi";
  const servicesTabLabel = user.role === "createur" ? "Mes services" : "Mes services disponibles";
  const reservesTabLabel = user.role === "createur" ? "Réservations reçues" : "Mes services confirmés";


  const getEmbedVideoUrl = (url) => {
  if (!url) return null;

  // YouTube
  if (url.includes("youtube.com") || url.includes("youtu.be")) {
    const videoId =
      url.includes("youtu.be")
        ? url.split("/").pop()
        : new URL(url).searchParams.get("v");

    return `https://www.youtube.com/embed/${videoId}`;
  }

  // Vimeo
  if (url.includes("vimeo.com")) {
    const videoId = url.split("/").pop();
    return `https://player.vimeo.com/video/${videoId}`;
  }

  // Sinon → lien direct mp4
  return url;
};
// Toujours convertir en tableau
const toArray = (value) => {
  if (!value) return [];

  // si c'est déjà un tableau
  if (Array.isArray(value)) {
    return value.flatMap(v => {
      if (typeof v === "string") {
        try {
          const parsed = JSON.parse(v);
          return Array.isArray(parsed) ? parsed : [v];
        } catch {
          return [v];
        }
      }
      return v;
    });
  }

  // si c'est une string JSON
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [value];
    } catch {
      return [value];
    }
  }

  return [];
};
const getDomaineStyle = () => {
  return {
    backgroundColor: "var(--accent-primary-soft)",
    color: "var(--accent-primary)",
    border: "1px solid var(--accent-primary)",
  };
};

const formatDisplayedHour = (rawDate, fallbackHeure) => {
  if (fallbackHeure && /^\d{2}:\d{2}$/.test(String(fallbackHeure))) {
    return String(fallbackHeure).replace(":", "h");
  }

  const match = String(rawDate || "").match(/T(\d{2}:\d{2})/);
  if (match?.[1]) {
    return match[1].replace(":", "h");
  }

  if (rawDate && String(rawDate).includes("T")) {
    return new Date(rawDate)
      .toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
      .replace(":", "h");
  }

  return "Heure à confirmer";
};

const extractEmail = (entity) => {
  if (!entity) return null;

  if (entity.role === "createur" || entity?.role === "createur") {
    return entity.emailDeContact || entity.mailDeContact || entity.contactEmail || null;
  }

  return entity.email || entity.mail || entity.contactEmail || null;
};

const resolveEmail = async (entity, fallbackId) => {
  const directEmail = extractEmail(entity);
  if (directEmail) {
    return directEmail;
  }

  const userId = String(fallbackId || entity?._id || "").trim();
  if (!userId) {
    return null;
  }

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `https://backend-qybe.onrender.com/api/users/${userId}`,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    return extractEmail(res.data);
  } catch {
    return null;
  }
};

const storedUser = JSON.parse(localStorage.getItem("user") || "null");
const currentUserId = String(user?.id || user?._id || storedUser?.id || storedUser?._id || "").trim();

const refreshStoredUser = (nextUser) => {
  const mergedUser = {
    ...(storedUser || {}),
    ...nextUser,
  };

  localStorage.setItem("user", JSON.stringify(mergedUser));
  setUser((prev) => ({
    ...(prev || {}),
    ...mergedUser,
    note: prev?.note,
    nombreAvis: prev?.nombreAvis,
  }));
};

const handlePhotoPickerOpen = () => {
  if (isPhotoUploading) return;
  photoInputRef.current?.click();
};

const handlePhotoChange = async (e) => {
  const selectedFile = e.target.files?.[0];
  e.target.value = "";

  if (!selectedFile || !currentUserId) return;

  const token = localStorage.getItem("token");
  if (!token) {
    navigate("/login");
    return;
  }

  const data = new FormData();
  data.append("photo", selectedFile);

  setIsPhotoUploading(true);

  try {
    const updateRes = await axios.put(
      `https://backend-qybe.onrender.com/api/auth/complete-profile/${currentUserId}`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (updateRes.data?.user) {
      refreshStoredUser(updateRes.data.user);
      return;
    }

    const profileRes = await axios.get(
      `https://backend-qybe.onrender.com/api/users/${currentUserId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    refreshStoredUser(profileRes.data);
  } catch (err) {
    console.error("Erreur lors de la mise à jour de la photo :", err);
  } finally {
    setIsPhotoUploading(false);
  }
};

/*
  const getNoteForService = (serviceId) => {
    const avisDuService = avis.filter(a => a.service?._id === serviceId);
    if (avisDuService.length === 0) return null;
    const note = avisDuService
      .map(a => {
        const n = typeof a.note === 'string' ? parseFloat(a.note) : a.note;
        return typeof n === 'number' && !isNaN(n) ? n : 0;
      })
      .reduce((acc, n) => acc + n, 0) / avisDuService.length;
    return note.toFixed(1);
  };

  // Gestion du formulaire
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleLangueChange = (langue) => {
    setForm((prev) => ({
      ...prev,
      langues: prev.langues.includes(langue)
        ? prev.langues.filter(l => l !== langue)
        : [...prev.langues, langue],
    }));
  };
*/
/*
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(form).forEach(key => {
      if (Array.isArray(form[key])) {
        form[key].forEach(item => data.append(key, item));
      } else {
        data.append(key, form[key] ?? '');
      }
    });

    try {
      await axios.put(`/api/users/${user.id}`, data, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      setUser(prev => ({ ...prev, ...form }));
      setEditMode(false);
      alert('Profil mis à jour avec succès !');
    } catch (err) {
      alert(err.response?.data?.msg || 'Erreur lors de la mise à jour');
    }
  };
*/
  // Annulation d'une réservation (mod #8)
  const handleCancelReservation = async (reservationId, serviceDate, refundedCredits = 0) => {
    const token = localStorage.getItem("token");
    if (!token) return;

    // Vérification 48h (mod #8.1)
    if (serviceDate) {
      const hoursUntil = (new Date(serviceDate) - new Date()) / (1000 * 60 * 60);
      if (hoursUntil < 48) {
        setCancelMessage("Annulation impossible : le service a lieu dans moins de 48h. Les crédits sont non remboursables.");
        setTimeout(() => setCancelMessage(""), 4000);
        return;
      }
    }

    try {
      const cancelRes = await axios.delete(
        `https://backend-qybe.onrender.com/api/reservations/${reservationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const storedUser = JSON.parse(localStorage.getItem("user") || "null");
      const backendCredits = cancelRes?.data?.user?.credits;
      const nextCredits =
        typeof backendCredits === "number"
          ? backendCredits
          : (storedUser?.credits ?? 0) + (Number(refundedCredits) || 0);

      if (storedUser) {
        const updatedUser = { ...storedUser, credits: nextCredits };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        window.dispatchEvent(new CustomEvent("creditsUpdated", { detail: updatedUser }));
      }

      setReservations(prev => prev.filter(r => r._id !== reservationId));
      setCancelMessage("Réservation annulée. Vos crédits ont été remboursés.");
      setTimeout(() => setCancelMessage(""), 3000);
    } catch (err) {
      setCancelMessage(err.response?.data?.msg || "Erreur lors de l'annulation.");
      setTimeout(() => setCancelMessage(""), 3000);
    }
  };

  const handleServiceAction = async (service) => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      if ((service.reservationsCount || 0) === 0) {
        await axios.delete(`https://backend-qybe.onrender.com/api/services/${service._id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setServices((prev) => prev.filter((s) => s._id !== service._id));
        setServiceActionMessage("Service supprimé avec succès.");
      } else {
        // Tentatives de désactivation selon les endpoints backend disponibles.
        try {
          await axios.patch(
            `https://backend-qybe.onrender.com/api/services/${service._id}/deactivate`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch {
          await axios.put(
            `https://backend-qybe.onrender.com/api/services/${service._id}`,
            { isActive: false, status: "inactive" },
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }

        setServices((prev) => prev.filter((s) => s._id !== service._id));
        setServiceActionMessage("Service désactivé : il n'est plus visible à la réservation.");
      }
    } catch (err) {
      setServiceActionMessage(err.response?.data?.msg || "Action impossible pour le moment.");
    } finally {
      setTimeout(() => setServiceActionMessage(""), 3500);
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
      {/* Header */}
      <header className="bg-white border-b px-6 py-4 flex items-center justify-between">

        { /* <img src={logo} alt="Logo" className="h-8" /> */}
        <button onClick={() => navigate("/dashboard")} className="link-fuchsia">
          ← Retour
        </button>
      </header>

      {/* Profil */}
      <main className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 flex flex-col md:flex-row items-center gap-8">
          <button
            type="button"
            onClick={handlePhotoPickerOpen}
            className="group relative rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)] focus-visible:ring-offset-2 disabled:cursor-wait"
            aria-label="Modifier la photo de profil"
            title="Modifier la photo de profil"
            disabled={isPhotoUploading}
          >
            <UserAvatar
              photo={user.photo}
              name={user.name}
              prenom={user.prenom}
              alt={`${user.prenom || ""} ${user.name || ""}`.trim()}
              className="w-32 h-32 border-2 border-[var(--accent-primary)] text-4xl transition-transform duration-200 group-hover:scale-[1.02]"
            />
            <div className="absolute inset-0 rounded-full bg-black/45 text-white opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity flex items-center justify-center text-center px-3">
              <span className="text-xs font-semibold leading-tight">
                {isPhotoUploading ? "Mise à jour..." : "Changer la photo"}
              </span>
            </div>
          </button>
          <input
            ref={photoInputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handlePhotoChange}
          />
          
        {/* <div className="text-center md:text-left flex-1"> */} 
        <div className="text-center md:text-left flex-1 min-w-0">

            <h1 className="text-3xl font-bold text-gray-800">{user.prenom} {user.name} </h1>
            {user.metier && <p className="text-lg text-gray-600">{user.metier}</p>}
            
            <div className="flex flex-wrap justify-center md:justify-start gap-2 mt-3">
  {toArray(user.domaine).map((domaine, index) => (
    <span
  key={index}
  style={getDomaineStyle(domaine)}
  className="
    px-3 py-1
    rounded-full
    text-sm
    font-medium
    break-words
    max-w-full
    whitespace-normal
  "
>
  {domaine}
</span>

  ))}
</div>


            <div className="flex flex-wrap justify-center md:justify-start items-center gap-6 mt-4 text-sm text-gray-600">
              {user.role === "createur" && (
                <>
                  <div className="flex items-center gap-1">🌍 <span> {toArray(user.langues).length > 0
    ? toArray(user.langues).join(", ")
    : "Non renseigné"}</span></div>
                  <div className="flex items-center gap-1">📍 <span>{user.lieuPrestation || "Non renseigné"}</span></div>
                </>
              )}
            </div>
          </div>

          
        </div>

        {/* Onglets */}
        <div className="flex flex-wrap gap-6 border-b mb-6">
            <button
              onClick={() => { setActiveTab("about"); setEditMode(false); }}
              className={`tab-accent font-medium ${activeTab === "about" ? "tab-accent-active" : "tab-accent-idle"}`}
            >
              {aboutTabLabel}
            </button>
          

          {user.role === "createur" && (
            <button
              onClick={() => { setActiveTab("services"); setEditMode(false); }}
              className={`tab-accent font-medium ${activeTab === "services" ? "tab-accent-active" : "tab-accent-idle"}`
            } >
              {servicesTabLabel}
            </button>
          )}

          <button
            onClick={() => { setActiveTab("reserves"); setEditMode(false); }}
            className={`tab-accent font-medium ${activeTab === "reserves" ? "tab-accent-active" : "tab-accent-idle"}`
          } >
            {reservesTabLabel}
          </button>

          {user.role === "createur" && (
            <button
              onClick={() => { setActiveTab("mesreservations"); setEditMode(false); }}
              className={`tab-accent font-medium ${activeTab === "mesreservations" ? "tab-accent-active" : "tab-accent-idle"}`}
            >
              Mes réservations
            </button>
          )}

          {user.role === "createur" && (
            <button
              onClick={() => { setActiveTab("avis"); setEditMode(false); }}
              className={`tab-accent font-medium ${activeTab === "avis" ? "tab-accent-active" : "tab-accent-idle"}`}
            >
              Témoignages
            </button>
          )}
           
        </div>

        {/* Contenu */}
        {activeTab === "about" && (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  
  {/* Bloc gauche : service OU message */}
  <div className="md:col-span-2 bg-white p-6 rounded-lg shadow">
    
   {/* Vidéo : afficher uniquement si présente */}
      {user.video && (
  <div className="w-full h-64 rounded-lg overflow-hidden mb-4">
    {user.video.includes("youtube") || user.video.includes("vimeo") ? (
      <iframe
        src={getEmbedVideoUrl(user.video)}
        title="Vidéo de présentation"
        className="w-full h-full"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    ) : (
      <video controls className="w-full h-full object-cover">
        <source src={user.video} type="video/mp4" />
      </video>
    )}
  </div>
)}


      {/* Description */}
      {user.description && (
        <p className="text-gray-700 mb-4 whitespace-pre-line">{user.description}</p>
      )}

       {/* Téléphone et nationalité */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
        {user.nationalites && <p><strong>Nationalité :</strong> {user.nationalites}</p>}
      </div>
  </div>

  {/* Bloc droite : LIENS (toujours au même endroit) */}
  {user.role === "createur" && (

  <div className="bg-white p-6 rounded-lg shadow h-fit">
    <h3 className="text-xl font-semibold mb-4 text-[var(--accent-primary)]">Liens</h3>

    {(user.siteWeb || user.instagram || user.linkedin) ? (
      <ul className="space-y-2 text-gray-800">
        {user.siteWeb && (
          <li>
           <strong>Site web :</strong>{" "}
            <a
              href={user.siteWeb.startsWith("http") ? user.siteWeb : `https://${user.siteWeb}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-accent underline break-all"
            >
              {user.siteWeb}
            </a>
          </li>
        )}

        {user.instagram && (
          <li>
         <strong>Instagram :</strong>{" "}
            <a
              href={user.instagram.startsWith("http") ? user.instagram : `https://${user.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-accent underline break-all"
            >

{user.instagram}      
      </a>
          </li>
        )}

        {user.linkedin && (
          <li>

     <strong>LinkedIn :</strong>{" "}
            <a
              href={user.linkedin.startsWith("http") ? user.linkedin : `https://${user.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-accent underline break-all"
            >
              {user.linkedin}
            </a>
          </li>
        )}
      </ul>
    ) : (
      <p className="text-gray-500 italic">
        Aucun lien renseigné.
      </p>
    )}
  </div>

)}


           <div className="md:col-span-3 flex flex-col space-y-4">

  {user.valeurs && (
    <div className="bg-white p-6 rounded-xl shadow">
      <h3 className="text-xl font-semibold mb-3 text-[var(--accent-primary)]">
        Mes valeurs profondes
      </h3>
      <p className="text-gray-700 whitespace-pre-line">{user.valeurs}</p>
    </div>
  )}

  {user.role === "createur" && (
    <div className="bg-white p-6 rounded-xl shadow">
      <h3 className="text-xl font-semibold mb-3 text-[var(--accent-primary)]">
        Informations pratiques
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
        <p><strong>Langues parlées :</strong>  {toArray(user.langues).length > 0
    ? toArray(user.langues).join(", ")
    : "Non renseigné"}</p>
        <p><strong>Type de séance :</strong> {user.typeCours || "Non renseigné"}</p>
        <p><strong>Email de contact :</strong> {creatorContactEmail || "Non renseigné"}</p>
        <p><strong>Téléphone :</strong> {user.telephone || "Non renseigné"}</p>
      </div>
    </div>
  )}

  {user.role === "createur" && (
    <div className="bg-white p-6 rounded-xl shadow">
      <h3 className="text-xl font-semibold mb-3 text-[var(--accent-primary)]">
        Portefeuille
      </h3>
      <div className="text-center">
        <p className="text-4xl font-bold text-[var(--accent-fuchsia)]">{user.credits}</p>
        <p className="credits-fuchsia mt-2">Solde de crédits</p>
      </div>
    </div>
  )}


</div>

{user.role === "particulier" && (
  <div className="mt-4">
    <h3 className="text-lg font-semibold mb-2 text-[var(--accent-primary)]">Coordonnées</h3>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
      <p>
        <strong>Email :</strong>{" "}
        <span className="break-all">
          {user.email || "Non renseigné"}
        </span>
      </p>

      <p>
        <strong>Téléphone :</strong>{" "}
        {user.telephone || "Non renseigné"}
      </p>
    </div>
  </div>
)}

          </div>
        )}
         {activeTab === "services" && (
          <div>
              {serviceActionMessage && (
                <div className={`mb-4 px-4 py-3 rounded-lg text-sm font-medium ${serviceActionMessage.includes("impossible") ? "bg-red-50 text-red-700" : "bg-green-50 text-green-700"}`}>
                  {serviceActionMessage}
                </div>
              )}
            {services.length === 0 ? (
              <p className="text-gray-500">Aucun service disponible.</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {services.map((s) => (
                  <div
                    key={s._id}
                    className="bg-white p-6 rounded-xl border border-gray-100 shadow hover:shadow-lg transition cursor-pointer"
                    onClick={() => navigate(`/service/${s._id}`)}
                  >
                    <div className="flex items-center gap-3 mb-3">
                        <div>
                    <h3 className="font-bold text-[var(--accent-primary)]">{s.titre}</h3>
                    </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mt-2">
  {/* Durée */}
  <span className="flex items-center gap-1">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
      stroke="#6b7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
    {s.typePrestation} et {s.lieu}
  </span>

  {/* Type prestation = collectif */}
  <span className="flex items-center gap-1">
     <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
{s.duree || "Non précisé"}  </span>

  {/* Date */}
  <span className="flex items-center gap-1">
     <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    </svg>
 {s.typeCours || "Individuelle"}  </span>
</div>
                    <div className="flex items-center justify-between mt-4">
                      <span className="credits-fuchsia font-semibold">{s.creditsProposes} crédits</span>
                      <div className="flex items-center gap-2">
                        <button
                          className="w-20 btn-primary py-2 text-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/editService/${s._id}`);
                          }}
                        >
                          Modifier
                        </button>
                        <button
                          className="px-3 py-2 rounded text-sm font-medium bg-[#F9BEE0] text-[#4a1d2d] hover:opacity-90"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleServiceAction(s);
                          }}
                        >
                          {(s.reservationsCount || 0) === 0 ? "Supprimer" : "Désactiver"}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {activeTab === "reserves" && (
          <div>
            {cancelMessage && (
              <div className={`mb-4 px-4 py-3 rounded-lg text-sm font-medium ${cancelMessage.includes("annulée") ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}`}>
                {cancelMessage}
              </div>
            )}
            {reservations.length === 0 ? (
              <p className="text-gray-500">Aucun services confirmés</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {reservations.map(r => {
                  const serviceDate =
                    r.selectedDate ||
                    r.dateService ||
                    (!r.service?.dateAConvenir && Array.isArray(r.service?.dateService) && r.service.dateService.length > 0
                      ? r.service.dateService[0]
                      : null);
                  const hoursUntil = serviceDate ? (new Date(serviceDate) - new Date()) / (1000 * 60 * 60) : Infinity;
                  const canCancel = hoursUntil > 48;
                  const reservationTime = formatDisplayedHour(serviceDate, r.service?.heure);
                  return (
                  <div key={r._id} className="bg-white p-6 rounded-xl border border-gray-100 shadow hover:shadow-lg transition">
                    <div>
                      <h3 className="font-bold text-[var(--accent-primary)]">{r.service?.titre}</h3>
                      <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mt-2">
  {/* Heure de réservation */}
  <span className="flex items-center gap-1">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    {reservationTime}
  </span>

  {/* Type prestation = collectif */}
  <span className="flex items-center gap-1">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    </svg>
    {r.service?.typePrestation || "Non précisé"}
  </span>

  {/* Date */}
 {/* Date : afficher UNIQUEMENT si le service a une date définie */}
{serviceDate && (
    <span className="flex items-center gap-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-4 h-4 text-gray-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
      {new Date(serviceDate).toLocaleDateString("fr-FR")}
    </span>
)}

</div>

                    </div>
                    <div className="flex items-center justify-between mt-4">
                      <span className="credits-fuchsia font-semibold">
                        {r.service?.creditsProposes || 0} crédits
                      </span>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={async () => {
                            const emailCreateur = await resolveEmail(
                              r.service?.createur || r.createur,
                              r.service?.createur?._id || r.createur?._id || r.service?.createurId || r.createurId
                            );
                            if (emailCreateur) {
                              window.location.href = `mailto:${emailCreateur}`;
                              return;
                            }
                            window.alert("Aucune adresse email disponible pour ce créateur.");
                          }}
                          className="btn-primary px-4 py-2 text-sm rounded-lg font-medium transition-colors"
                        >
                          Contacter
                        </button>
                        <button
                          onClick={() => handleCancelReservation(r._id, serviceDate, r.service?.creditsProposes)}
                          className={`px-4 py-2 rounded font-medium text-sm transition-colors ${canCancel ? "bg-[#F9BEE0] text-[#4a1d2d] hover:opacity-90" : "bg-[#F9BEE0] text-[#4a1d2d] opacity-60 cursor-not-allowed"}`}
                          title={!canCancel ? "Annulation impossible : moins de 48h avant le service" : "Annuler cette réservation"}
                        >
                          Annuler
                        </button>
                      </div>
                    </div>
                  </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
        {user.role === "createur" && activeTab === "mesreservations" && (
          <div>
            {reservationsRecues.length === 0 ? (
              <p className="text-gray-500">Aucune réservations</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {reservationsRecues.map(r => {
                  const reservationDate =
                    r.selectedDate ||
                    r.dateService ||
                    (!r.service?.dateAConvenir && Array.isArray(r.service?.dateService) && r.service.dateService.length > 0
                      ? r.service.dateService[0]
                      : null);
                  const reservationHour = formatDisplayedHour(reservationDate, r.service?.heure);

                  return (
                  <div key={r._id} className="bg-white p-6 rounded-xl border border-gray-100 shadow hover:shadow-lg transition">
                    <div>
                      <h3 className="font-bold text-[var(--accent-primary)]">{r.service?.titre}</h3>
                      <div className="flex items-center gap-2 mt-2">
                        <UserAvatar
                          photo={r.utilisateur?.photo}
                          name={r.utilisateur?.name}
                          prenom={r.utilisateur?.prenom}
                          className="w-8 h-8"
                        />
                        <span className="text-sm text-gray-700 font-medium">
                          {r.utilisateur?.prenom} {r.utilisateur?.name}
                        </span>
                      </div>
                      {reservationDate && (
                        <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mt-2">
                          <span className="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              />
                            </svg>
                            {new Date(reservationDate).toLocaleDateString("fr-FR")}
                          </span>
                          <span className="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {reservationHour}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="flex items-center justify-between mt-4">
                      <span className="text-sm text-gray-500">Réservation reçue</span>
                      <button
                        onClick={async () => {
                          const emailUtilisateur = await resolveEmail(
                            r.utilisateur,
                            r.utilisateur?._id || r.utilisateurId || r.userId
                          );
                          if (emailUtilisateur) {
                            window.location.href = `mailto:${emailUtilisateur}`;
                            return;
                          }
                          window.alert("Aucune adresse email disponible pour cet utilisateur.");
                        }}
                        className="btn-primary px-4 py-2 text-sm rounded-lg font-medium transition-colors"
                      >
                        Contacter
                      </button>
                    </div>
                  </div>
                );})}
              </div>
            )}
          </div>
        )}
   {user.role === "createur" && activeTab === "avis" && (
  <div>
    {avis.length === 0 ? (
      <p className="text-gray-500">Aucun témoignages</p>
    ) : (
      <div className="space-y-4">
        {avis.map(a => (
          <div key={a._id} className="bg-white p-4 rounded-xl shadow">
            <div className="flex items-center gap-3">
              <UserAvatar
                photo={a.auteur?.photo}
                name={a.auteur?.name}
                prenom={a.auteur?.prenom}
                className="w-10 h-10"
              />
              <div className="flex-1">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">
                      {a.auteur?.name} {a.auteur?.prenom}
                    </p>
                  </div>
                  <span className="text-sm text-gray-400">
                    {new Date(a.createdAt).toLocaleDateString("fr-FR")}
                  </span>
                </div>
              </div>
            </div>
            <p className="mt-2 text-gray-700">{a.commentaire}</p>
            <p className="mt-1 text-sm italic text-gray-500">Service reçu : {a.serviceRecu || a.service?.titre || "Non renseigné"}</p>
          </div>
        ))}
      </div>
    )}
  </div>
)}

        {/* Autres onglets : services, réserves, etc. */}
        {/* ... (garde le reste inchangé) */}
      </main>
      <Footer />
    </div>
  );
};

export default Profile;
